<template>
  <div class="page-container">
    <!---------------- Hero Section ---------------->
    <section class="hero-section">
      <video autoplay loop muted playsinline class="hero-video">
        <source
          :src="
            getCDNlink(
              'assets/new-assets/Partnerships/partnership_hero_section.webm'
            )
          "
          type="video/webm"
        />
        Your browser does not support the video tag.
      </video>
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <div class="resources-badge">Partnerships</div>
        <h1 class="hero-title">
          Collaborate.
          <br />
          Innovate. <span class="blue-text">Scale.</span>
        </h1>
        <p class="hero-subtitle">
          At Credence, we believe in the power of collaboration. By partnering
          with industry leaders,<br />
          we enhance capabilities, improve data-driven decisions, and empower
          businesses globally.
        </p>
      </div>
    </section>
    <!---------------- Why Partner With Us ---------------->
    <section class="credence-advantage">
      <div class="container">
        <!-- Government Support Badge -->
        <div class="support-badge">
          <span>What We Offer</span>
        </div>

        <!-- Main Heading Section -->
        <h2 class="main-heading">Why Partner With Credence Data?</h2>
        <p class="description">
          We work with a diverse ecosystem of partners to drive innovation, open
          new market opportunities, and enable faster go-to-market strategies.
        </p>
        <!-- Feature Cards -->
        <div class="advantage-list-cards">
          <!-- Row 1 -->
          <div class="advantage-row-1">
            <!-- Card1 -->
            <div class="advantage-2">
              <div
                class="illustration-adv-2"
                :style="{
                  backgroundImage: `url(${getCDNlink(
                    'assets/new-assets/Partnerships/data_expertise_at_scale.webp'
                  )})`,
                }"
              >
                <img
                  class="cargo-ship-1-icon"
                  alt=""
                  :src="
                    getCDNlink(
                      'assets/new-assets/Partnerships/data_expertise_at_scale.gif'
                    )
                  "
                />
              </div>
              <div class="content-adv-2">
                <div class="made-for-asia">Data Expertise at Scale</div>
                <div class="coverage-of-important">
                  Leverage our advanced capabilities in data analytics, AI/ML,
                  and data insights to enhance your solution portfolio—powered
                  by data from 230+ countries and over 400 million entities.
                </div>
              </div>
            </div>
            <!-- Card2 -->
            <div class="advantage-1">
              <div class="content-adv-1">
                <div class="made-for-asia">Accelerate Customer Value</div>
                <div class="coverage-of-important">
                  Leverage our modular, API-first data products to enhance your
                  platform’s impact, improve client outcomes, and reduce
                  time-to-insight. Quick setup, seamless integration, and robust
                  technical support for APIs.
                </div>
              </div>
              <div class="img-1-wrapper">
                <div
                  class="illustration-adv-1"
                  :style="{
                    backgroundImage: `url(${getCDNlink(
                      'assets/new-assets/Partnerships/accelerate_customer_value.webp'
                    )})`,
                  }"
                >
                  <img
                    class="globe-gif-icon"
                    alt=""
                    :src="
                      getCDNlink(
                        'assets/new-assets/Partnerships/accelerate_customer_value.gif'
                      )
                    "
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- Row 2 -->
          <div class="advantage-row-1">
            <!-- Card 1 -->
            <div class="advantage-1">
              <div class="content-card-4">
                <div class="made-for-asia">
                  Knowledge leaders in Cross border trade
                </div>
                <div class="coverage-of-important">
                  With deep domain expertise in international trade flows,
                  customs data, and entity-level linkages, we bring unparalleled
                  insight to help partners navigate complexity and build
                  globally scalable solutions.
                </div>
              </div>
              <div class="illustration-card-4">
                <div class="globe-icon-wrapper">
                  <img
                    class="globe-icon"
                    :src="
                      getCDNlink(
                        'assets/new-assets/Partnerships/knowledge_leaders_trade.webp'
                      )
                    "
                    alt="Globe icon"
                  />
                </div>
                <div class="globe-graphic">
                  <img
                    class="globe-illustration"
                    :src="
                      getCDNlink(
                        'assets/new-assets/Partnerships/knowledge_leaders_trade.gif'
                      )
                    "
                    alt="Global trade network"
                  />
                </div>
              </div>
            </div>
            <!-- Card 2 -->
            <div class="advantage-2">
              <div
                class="illustration-adv-3"
                :style="{
                  backgroundImage: `url(${getCDNlink(
                    'assets/new-assets/Partnerships/Go_To_Market.webp'
                  )})`,
                }"
              >
                <img
                  class="bolt-fast-icon"
                  :src="
                    getCDNlink(
                      'assets/new-assets/Partnerships/Go_To_Market.gif'
                    )
                  "
                  alt="Global trade network"
                />
              </div>
              <div class="content-adv-2">
                <div class="made-for-asia">Go-To-Market Synergies</div>
                <div class="coverage-of-important">
                  Attractive co-marketing opportunities wherein, we collaborate
                  closely on providing data for counterparties and countries
                  that you don’t have access to reach the right
                  customers-together. In addition, we can make the delivery time
                  faster for fresher data to your customers.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--------------- Partnership Opportunities Section --------------->
    <section class="credence-advantage partnership-section">
      <!-- Card Grid 1 -->
      <div class="container">
        <div class="support-badge">
          <span>Partnership Opportunities</span>
        </div>
        <h2 class="partnership-heading">
          Distribution & Go-to-Market Partners
        </h2>

        <div class="feature-grid">
          <div class="feature-card first-card">
            <div class="card-icons">
              <span class="icon" v-html="partnershipsIcons?.commentIcon"></span>
              <div class="card-icon-separator"></div>
              <span class="icon" v-html="partnershipsIcons?.peopleIcon"></span>
            </div>
            <h3 class="feature-title">
              Influencers & Industry Thought Leaders
            </h3>
            <p class="feature-description">
              Partner with us to promote the future of data-driven
              decision-making in cross-border trade and risk intelligence.
              Collaborate on events, webinars, and outreach campaigns. If you
              have reach with local corporates and banks in any country, we are
              keen to engage with you.
            </p>
          </div>

          <div class="feature-card">
            <div class="card-icons">
              <span class="icon" v-html="partnershipsIcons?.cube"></span>
              <div class="card-icon-separator"></div>
              <span class="icon" v-html="partnershipsIcons?.bookmark"></span>
            </div>
            <h3 class="feature-title">TradeTech Ecosystems & Marketplaces</h3>
            <p class="feature-description">
              Partner with us to bring curated data services into digital
              marketplaces or embedded fintech experiences. Co-develop
              integrations and APIs that power real-time decisions.
            </p>
          </div>

          <div class="feature-card">
            <div class="card-icons">
              <span class="icon" v-html="partnershipsIcons?.marketPlace"></span>
              <div class="card-icon-separator"></div>
              <span class="icon" v-html="partnershipsIcons?.hubs"></span>
            </div>
            <h3 class="feature-title">
              Platform, B2B Marketplace & Procurement Hubs
            </h3>
            <p class="feature-description">
              Distribute Credence’s data intelligence products in your region or
              sector. We support with enablement content, co-branded assets, and
              technical training for rapid market adoption.
            </p>
          </div>

          <div class="feature-card">
            <div class="card-icons">
              <span class="icon" v-html="partnershipsIcons?.logistics"></span>
              <div class="card-icon-separator"></div>
              <span class="icon" v-html="partnershipsIcons?.resellers"></span>
            </div>
            <h3 class="feature-title">Value-Added Resellers (VARs)</h3>
            <p class="feature-description">
              Bundle our data solutions into your service offerings for
              logistics, ERP, or analytics clients. Earn margins while solving
              real-world challenges with verified data.
            </p>
          </div>

          <div class="feature-card">
            <div class="card-icons">
              <span class="icon" v-html="partnershipsIcons?.audit"></span>
              <div class="card-icon-separator"></div>
              <span class="icon" v-html="partnershipsIcons?.assurance"></span>
            </div>
            <h3 class="feature-title">Audit & Assurance Firms</h3>
            <p class="feature-description">
              Leverage accurate, timely, and comprehensive data to enhance audit
              accuracy, efficiency, and compliance verification processes.
            </p>
          </div>
        </div>
      </div>
      <!-- Card Grid 2 -->
      <div class="container">
        <h2 class="partnership-heading">Data Consumers & Integrators</h2>
        <div class="feature-grid">
          <div class="feature-card">
            <div class="card-icons card-icons-2">
              <span class="icon" v-html="partnershipsIcons?.consulting"></span>
              <div class="card-icon-separator1"></div>
              <span class="icon" v-html="partnershipsIcons?.integrator"></span>
            </div>
            <h3 class="feature-title">Consulting & Advisory Firms</h3>
            <p class="feature-description">
              Enhance your digital transformation, risk, or strategy consulting
              services by embedding Credence’s data and analytics into your
              client deliverables — from market intelligence to supply chain
              risk modeling.
            </p>
          </div>

          <div class="feature-card">
            <div class="card-icons card-icons-2">
              <span class="icon" v-html="partnershipsIcons?.corporates"></span>
              <div class="card-icon-separator1"></div>
              <span
                class="icon"
                v-html="partnershipsIcons?.multinationals"
              ></span>
            </div>
            <h3 class="feature-title">Corporates & Multinationals</h3>
            <p class="feature-description">
              Streamlined vetting processes for safe aGain visibility into your
              supplier networks, peer benchmarking, and third-party trade
              relationships for enhanced due diligence and procurement
              optimization.nd informed decision-making.
            </p>
          </div>
          <div class="feature-card first-card">
            <div class="card-icons card-icons-2">
              <span class="icon" v-html="partnershipsIcons?.supplyChain"></span>
              <div class="card-icon-separator1"></div>
              <span
                class="icon"
                v-html="partnershipsIcons?.financePlatforms"
              ></span>
            </div>
            <h3 class="feature-title">Supply Chain Finance Platforms</h3>
            <p class="feature-description">
              Use Credence’s entity-linked shipment intelligence to strengthen
              supplier risk scoring, assess financials, and uncover related
              party connections. Improve underwriting accuracy and reduce
              onboarding friction with trusted trade data.
            </p>
          </div>

          <div class="feature-card">
            <div class="card-icons card-icons-2">
              <span
                class="icon"
                v-html="partnershipsIcons?.technologyPartners"
              ></span>
              <div class="card-icon-separator1"></div>
              <span
                class="icon"
                v-html="partnershipsIcons?.technologyPartners1"
              ></span>
            </div>
            <h3 class="feature-title">Technology Partners</h3>
            <p class="feature-description">
              Integrate AI-powered analytics and cross-border trade intelligence
              into your digital products. Whether you’re building tools for
              procurement, logistics, compliance, or credit risk — our data
              layers plug in easily.
            </p>
          </div>

          <div class="feature-card">
            <div class="card-icons card-icons-2">
              <span
                class="icon"
                v-html="partnershipsIcons?.institutions"
              ></span>
              <div class="card-icon-separator1"></div>
              <span
                class="icon"
                v-html="partnershipsIcons?.creditBeureaus"
              ></span>
            </div>
            <h3 class="feature-title">
              Financial Institutions & Credit Bureaus
            </h3>
            <p class="feature-description">
              Streamlined vetting Access trade-based behavioral data, customs
              filings, and shipment trails to enrich SME credit models, KYC
              profiles, or compliance workflows, processes for safe and informed
              decision-making.
            </p>
          </div>
        </div>
      </div>
    </section>
    <!---------------- Let's Build Section ---------------->
    <section class="credence-advantage">
      <div
        class="mission-tagline"
        :style="{
          '--bg-image2': `url(${getCDNlink(
            'assets/new-assets/Statistics-BG.webp'
          )})`,
        }"
      >
        <h3>
          Let’s Build the Future<br />
          of Data Intelligence - Together
        </h3>
        <p class="description" style="color: #fff">
          Whether you’re looking to strengthen your existing offerings or expand
          into new domains, Credence is your trusted partner for innovation at
          scale. Interested in partnering with us? Fill the form and connect
          with us.
        </p>
        <div class="cta-container">
          <div class="cta-buttons">
            <button
              class="cta-button primary"
              @click="this.$router.push('/contact')"
            >
              Contact Us
              <span v-html="partnershipsIcons?.contactUsIcon"></span>
            </button>
          </div>
        </div>
      </div>
    </section>
    <Footer class="footer-instance"></Footer>
  </div>
</template>
<script>
import config from "@/config";
import { partnershipsIcons } from "@/assets/Icons/partnershipsIcons.js";
import Footer from "@/components/HomePage/Footer/Footer.vue";

export default {
  name: "PartnershipsPage",
  components: {
    Footer,
  },
  data() {
    return {
      partnershipsIcons,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResponsive);
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResponsive);
  },
  methods: {
    handleResponsive() {
      return window.innerWidth <= 480
    },
    getCDNlink(fileKey) {
      let baseUrl = "";
      if (
        process.env.NODE_ENV === "development" ||
        process.env.NODE_ENV === "staging"
      ) {
        baseUrl = config.stagingCDN;
      } else if (process.env.NODE_ENV === "production") {
        baseUrl = config.prodCDN;
      }

      return `${baseUrl}${fileKey}`;
    },
  },
};
</script>
<style scoped>
/* Global Styles */
.page-container {
  font-family: "Inter", "Helvetica Neue", Arial, sans-serif;
  color: #333;
  line-height: 1.5;
  overflow-x: hidden;
  min-height: 100vh;
}
/* Hero Section */
.hero-section {
  position: relative;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow: hidden;
}

.hero-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    119.63% 62.25% at 50% 50%,
    #000000eb 0%,
    rgba(0, 0, 0, 0) 100%
  );
  z-index: 2;
}

.hero-content {
  position: relative;
  z-index: 3;
  display: flex;
  padding: 0px 160px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
}

.hero-title {
  text-align: center;
  font-family: "Figtree";
  font-size: 68px;
  font-style: normal;
  font-weight: 500;
  line-height: 79.2px;
  letter-spacing: -1.44px;
  background: var(
    --Home-Banner-Title-Gradient,
    radial-gradient(
      82.47% 140.95% at 31.38% -13.87%,
      #fff 36%,
      #ffece0 64%,
      #72b4ff 88.94%
    )
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
}

.blue-text {
  color: #046be1;
}

.hero-subtitle {
  color: #fff;
  text-align: center;
  font-family: "Figtree";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  align-self: stretch;
  margin: 0;
}
.resources-badge {
  display: inline-block;
  padding: 12px 16px;
  color: #c94374;
  font-size: 0.875rem;
  font-weight: 600;
  border: 1px solid #c94374;
  border-radius: 50px;
  margin-bottom: 1.2rem;
  width: fit-content;
  letter-spacing: 1px;
}
/* Why partner with us */
.credence-advantage {
  width: 100%;
  position: relative;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  gap: 64px;
  text-align: center;
  font-size: 16px;
  color: #1c1c1c;
  font-family: Figtree;
  height: 100%;
  padding: 80px 140px;
  text-align: justify;
}

.container {
  margin: 0;
  width: -webkit-fill-available;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Government Support Badge */
.support-badge {
  display: inline-flex;
  padding: 0.5rem 1.5rem;
  border-radius: 9999px;

  border: 1px solid #c94374;
}

.support-badge span {
  color: #c94374;
  font-size: 14px;
  font-weight: 500;
}

/* Main Heading Section */
.main-heading {
  color: #1e3a8a;
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-align: center;
}

.tagline {
  color: #1c1c1c;
  font-size: 24px;
  font-weight: 500;
  margin: 0;
  text-align: center;
}

.description {
  color: #1c1c1c;
  font-size: 18px;
  line-height: 1.3;
  text-align: center;
}
/* Adavantage Cards */

.made-for-asia {
  align-self: stretch;
  position: relative;
  letter-spacing: -0.02em;
  line-height: 120%;
  font-weight: 600;
  font-size: 24px;
}
.coverage-of-important {
  align-self: stretch;
  position: relative;
  font-size: 18px;
  line-height: 124%;
  font-weight: 500;
}
.content-adv-1 {
  align-self: stretch;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 32px;
  gap: 8px;
}
.globe-gif-icon {
  width: 35%;
  height: auto;
  max-width: 100px;
  transform: scaleX(-1) rotate(5deg);
  position: relative;
  top: 25%;
  object-fit: contain;
}
.illustration-adv-1 {
  flex: 1;
  height: 370px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-1-wrapper {
  display: contents;
}
.advantage-1 {
  align-self: stretch;
  flex: 1.3;
  border-radius: 16px;
  background: linear-gradient(180deg, #e4efff, #eef1ff);
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
}
.cargo-ship-1-icon {
  width: 80px;
  position: relative;
  border-radius: 8px;
  max-height: 100%;
  object-fit: cover;
}
.illustration-adv-2 {
  align-self: stretch;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 27px 157px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top;
}
.content-adv-2 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 32px;
  gap: 8px;
}
.advantage-2 {
  align-self: stretch;
  flex: 1;
  border-radius: 16px;
  background: linear-gradient(180deg, #e4efff, #eef1ff);
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}
.advantage-row-1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 32px;
}
.bolt-fast-icon {
  width: 66px;
  position: relative;
  max-height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.illustration-adv-3 {
  align-self: stretch;
  height: 200px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0px 5px;
  box-sizing: border-box;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top;
}
.content-card-4 {
  width: 340px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 32px;
  box-sizing: border-box;
  gap: 8px;
}
.data-network-illustration {
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom center;
  z-index: 1;
}
.informed-icon {
  width: 40%;
  max-width: 180px;
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 2;
  object-fit: contain;
}
.illustration-card-4 {
  align-self: stretch;
  flex: 1;
  position: relative;
  display: flex;
  min-height: 200px;
  padding: 20px;
  overflow: hidden;
}
.advantage-list-cards {
  width: -webkit-fill-available;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 32px;
  text-align: left;
  font-size: 24px;
  color: #1c1c1c;
  font-family: Figtree;
}

.globe-icon {
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
}

.globe-illustration {
  height: 21%;
  position: absolute;
  left: 0;
  top: 45px;
}

.partnership-section {
  background: radial-gradient(50% 50% at 50% 50%, #0f0d43, #1d1016);
}
.partnership-heading {
  text-align: center;
  font-family: "Figtree";
  font-style: normal;
  font-weight: 500;
  line-height: 79.2px;
  letter-spacing: -1.44px;
  background: var(
    --Home-Banner-Title-Gradient,
    radial-gradient(
      82.47% 140.95% at 31.38% -13.87%,
      #fff 36%,
      #ffece0 64%,
      #72b4ff 88.94%
    )
  );
  font-size: 48px;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
/* Grid cards */
.feature-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  width: 90%;
  margin: 0 auto;
  max-width: 1200px;
}

.feature-card {
  background: linear-gradient(78.13deg, #edf8ff, #eff1ff);
  border-radius: 16px;
  box-shadow: 0px 1px 11px rgba(17, 54, 90, 0.2);
  padding: 40px 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.first-card {
  grid-column: 1 / -1;
}
.card-icons {
  border: 1.2px solid #0172f4;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 0px 19px;
  gap: 5px;
  margin: 0 auto;
}
.card-icons-2 {
  border: 1.2px solid #c94374;
}

.icon {
  margin: 4px 0px;
}

.card-icon-separator {
  width: 1px;
  height: 100%;
  background-color: #0172f4;
  margin: 0px 5px;
}

.card-icon-separator1 {
  width: 1px;
  height: 100%;
  background-color: #c94374;
  margin: 0px 5px;
}

.last {
  max-width: 46%;
}

.feature-image {
  width: 64px;
  height: 64px;
  object-fit: contain;
  margin: 0 auto;
}

.feature-title {
  font-size: 24px;
  font-weight: 600;
  color: #1c1c1c;
  margin: 0;
}

.feature-description {
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  color: #1c1c1c;
  margin: 0;
}

.mission-tagline {
  width: -webkit-fill-available;
  background: #1c1c1c;
  background-image: var(--bg-image2);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  padding: 60px;
  border-radius: 24px;
  text-align: center;
  align-content: center;
}

.mission-tagline h3 {
  text-align: center;
  font-family: "Figtree";
  font-size: 48px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: -1.44px;
  margin-top: 0;
  color: #fff;
  line-height: 58px;
}

.text-ai {
  color: #4a90e2;
  font-weight: 400;
}

.text-trust {
  color: #4a90e2;
  font-weight: 400;
}

.cta-container {
  max-width: -webkit-fill-available;
  margin: 0;
  text-align: center;
  position: relative;
  z-index: 1;
}

.cta-buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.cta-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.875rem 1.75rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 173px;
}

.cta-button.primary {
  background-color: #c94374;
  color: #ffffff;
}

.cta-button.primary:hover {
  background-color: #e43a7a;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(253, 76, 140, 0.3);
}

@media (max-width: 768px) {
  .hero-content {
    padding: 45px 40px;
  }
  .hero-title {
    font-size: 50px;
    line-height: 47px;
    text-align: left;
  }
  .hero-subtitle {
    font-size: 22px;
    text-align: left;
  }
  .section-title {
    font-size: 36px;
  }
  .section-subtitle {
    font-size: 18px;
    margin: 1rem 0;
  }
  .feature-grid {
    grid-template-columns: 1fr;
    width: -webkit-fill-available;
  }
  .credence-advantage {
    padding: 45px 40px;
  }
  .partnership-heading,
  .main-heading {
    line-height: 41px;
    font-size: 36px;
  }
  .advantage-row-1 {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .hero-section {
    height: auto;
  }
  .hero-title {
    font-size: 48px;
    line-height: 50px;
    text-align: left;
  }

  .hero-content {
    padding: 70px 20px 40px 20px;
  }

  .hero-subtitle {
    font-size: 16px;
    text-align: left;
  }

  .section-title {
    font-size: 36px;
    line-height: 45px;
  }

  .section-subtitle {
    font-size: 16px;
    margin: 1rem 0;
  }
  .credence-advantage {
    padding: 25px;
    gap: 25px;
  }

  .partnership-heading,
  .main-heading {
    line-height: 38px;
    font-size: 36px;
  }
  .description {
    font-size: 16px;
  }
  .mission-tagline h3 {
    font-size: 36px;
    line-height: 45px;
  }
  .advantage-row-1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 24px;
    width: -webkit-fill-available;
  }
  .illustration-adv-2 {
    padding: 21px 120px;
  }
  .advantage-1 {
    flex-direction: column;
  }
  .made-for-asia {
    font-size: 18px;
  }
  .coverage-of-important {
    font-size: 14px;
  }
  .content-adv-2 {
    padding: 15px;
  }
  .cargo-ship-1-icon {
    width: 58px;
  }
  .illustration-adv-1 {
    width: 270px;
  }
  .content-card-4 {
    width: auto;
    padding: 15px;
  }
  .globe-illustration {
    height: 30%;
    position: absolute;
    left: 35px;
    top: 45px;
  }
  .bolt-fast-icon {
    width: 43px;
    position: relative;
    max-height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    border-radius: 50%;
    top: -21px;
  }
  .illustration-adv-3 {
    height: 135px;
  }
  .illustration-card-4,
  .content-adv-1 {
    padding: 15px;
  }
  .feature-title {
    font-size: 18px;
    line-height: 20px;
  }
  .feature-description {
    font-size: 14px;
    line-height: 16px;
  }
  .feature-card {
    gap: 18px;
    padding: 20px;
  }
  .mission-tagline {
    padding: 25px 18px;
  }
  .icon {
    margin: 3px 0px;
    height: 32px;
  }

  .illustration-adv-1 {
    width: 136px;
  }

  .illustration-adv-1 {
    flex: auto;
    height: 160px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
